export const getQuerySpecsPerEntity: (query: string) =>
	| {
			searchQuery: string;
			entities: string[];
			spacesFilter: undefined;
			needsLinkResolution?: undefined;
	  }
	| {
			searchQuery: string;
			entities: string[];
			spacesFilter: string[];
			needsLinkResolution?: undefined;
	  }
	| {
			searchQuery: string;
			entities: string[];
			spacesFilter: undefined;
			needsLinkResolution: boolean;
	  } = (query: string) => {
	const pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
	const spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
	// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
	const confluenceTinyRegex = /\/wiki\/x\/(?<resourceId>[^\/(?)]+)$/;
	const queryParts = query.split('/');
	const queryParamsRemoved = query.split('?')[0];

	if (query.match(pageOrBlogRegex)) {
		// e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
		return {
			searchQuery: queryParts[queryParts.length - 1],
			entities: ['ati:cloud:confluence:page', 'ati:cloud:confluence:blogpost'],
			spacesFilter: undefined,
		};
	} else if (query.match(spaceRegex)) {
		// e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
		const spacesIndex = queryParts.indexOf('spaces');
		return {
			searchQuery: '',
			entities: ['ati:cloud:confluence:space'],
			spacesFilter: [spacesIndex > -1 ? queryParts[spacesIndex + 1] : ''],
		};
	} else if (queryParamsRemoved.match(confluenceTinyRegex)) {
		// e.g. https://hello.atlassian.net/wiki/x/4c942w
		return {
			searchQuery: '',
			entities: ['ati:cloud:confluence:page', 'ati:cloud:confluence:blogpost'],
			spacesFilter: undefined,
			needsLinkResolution: true,
		};
	}
	return {
		searchQuery: query,
		entities: [
			'ati:cloud:confluence:page',
			'ati:cloud:confluence:blogpost',
			'ati:cloud:confluence:space',
		],
		spacesFilter: undefined,
	};
};
